<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('w00')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('w02')">
                                    <el-input v-model="searchform.voiceId" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('w04')">
                                    <el-input v-model="searchform.phoneName" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('w05')">
                                    <el-input v-model="searchform.callee" style="width: 150px;" @keyup.enter.native="onSubmit" size="small"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="userName" :label="$t('w01')" ></el-table-column>
                        <el-table-column prop="voiceId" :label="$t('w02')" ></el-table-column>
                        <el-table-column prop="walkie" :label="$t('w04')"></el-table-column>
                        <el-table-column prop="callee" :label="$t('w05')" ></el-table-column>
                        <el-table-column prop="orderNo" label="orderid"></el-table-column>
                        <el-table-column prop="direction" :label="$t('nxc1')"></el-table-column>
                        <el-table-column prop="hangupCause" :label="$t('nxc2')"></el-table-column>
                        <el-table-column prop="answerTime" :label="$t('nxc3')"></el-table-column>
                        <el-table-column prop="startTime" :label="$t('nxc4')"></el-table-column>
                        <el-table-column prop="endTime" :label="$t('nxc5')"></el-table-column>
                        <el-table-column prop="duration" :label="$t('nxc6')"></el-table-column>
                        <el-table-column prop="callplatform" :label="$t('c24')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="188px" fixed="right">
                            <template slot-scope="scope">
                                <el-popconfirm style="margin-left: 10px;" :title="$t('re16')" v-if="scope.row.recordUrl != null && scope.row.duration > 0" @confirm="queryRecord(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-view" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            return {
                loading: false,
                list: [],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                user:null,
            }
        },
        created() {
            this.user = JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getList()
        },
        methods: {
            queryRecord(row) {
                window.open(row.recordUrl, '_blank');
            },
            getNowTime() {
                const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 2)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0] //默认开始时间7天前
                const end = new Date(new Date().getTime() + 3600 * 1000 * 24)
                    .toISOString()
                    .replace('T', ' ')
                    .split('.')[0]//默认结束时间1天前
                return [start, end]
            },
            checkdata(){
                this.getList()
            },
            getList() {
                this.loading = true
                _api.get(apiurl.walky, {
                    page: this.pageNo,
                    size: this.pageSize,
                    voiceId: this.searchform.voiceId,
                    phoneName: this.searchform.phoneName,
                    callee: this.searchform.callee,
                    createTime: this.value1,
                    duration:1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>